/**
 * Image URL for a tenant logo: API base64 (optional mime) or HTTP(S) / data URL from {@link logoUrl}.
 * @param {{ logoUrl?: string|null, logoBase64?: string|null, logoMimeType?: string|null }} tenant
 * @returns {string|null}
 */
export function tenantLogoImageSrc(tenant) {
  const rawB64 =
    tenant.logoBase64 != null && String(tenant.logoBase64).trim() !== ""
      ? String(tenant.logoBase64).trim()
      : null;
  if (rawB64) {
    if (rawB64.startsWith("data:")) return rawB64;
    const mime =
      tenant.logoMimeType != null &&
      String(tenant.logoMimeType).trim() !== "" &&
      String(tenant.logoMimeType).includes("/")
        ? String(tenant.logoMimeType).trim()
        : "image/png";
    return `data:${mime};base64,${rawB64}`;
  }
  const url =
    tenant.logoUrl != null && String(tenant.logoUrl).trim() !== ""
      ? String(tenant.logoUrl).trim()
      : null;
  return url;
}

/**
 * Deterministic background class for tenant initials (Tailwind palette).
 * @param {string} seed
 * @returns {string}
 */
export function tenantAvatarColorClass(seed) {
  const palette = [
    "bg-primary text-white",
    "bg-slate-600 text-white",
    "bg-emerald-600 text-white",
    "bg-violet-600 text-white",
    "bg-amber-600 text-white",
    "bg-rose-600 text-white",
    "bg-cyan-700 text-white",
    "bg-indigo-600 text-white",
  ];
  let h = 0;
  const s = String(seed || "");
  for (let i = 0; i < s.length; i++) {
    h = (h * 31 + s.charCodeAt(i)) >>> 0;
  }
  return palette[h % palette.length];
}

/**
 * Two-letter initials from display name or fallback.
 * @param {string} displayName
 * @param {string} [fallback]
 * @returns {string}
 */
export function tenantInitials(displayName, fallback = "?") {
  const trimmed = String(displayName || "").trim();
  if (!trimmed) return fallback.slice(0, 2).toUpperCase();
  const parts = trimmed.split(/\s+/).filter(Boolean);
  if (parts.length >= 2) {
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  }
  const word = parts[0];
  return word.length >= 2
    ? word.slice(0, 2).toUpperCase()
    : `${word[0]}${word[0]}`.toUpperCase();
}
